import axios from "axios";

const RESSOURCE_NAME = "roles";

export default {
  getRoles() {
    return axios.get(`${RESSOURCE_NAME}`);
  },
};
